import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import PasswordReset from './views/PasswordReset.vue'
import Sales from './views/Sales.vue'
import Incomes from './views/Incomes.vue'
import Expenses from './views/Expenses.vue'
import Assumptions from './views/Assumptions.vue'
import BudgetReport from './views/BudgetReport.vue'
import Welcome from './views/Welcome.vue'
import Offers from './views/Offers.vue'
import OfferDetails from './views/OfferDetails.vue'
import PersonnelRatings from './views/PersonnelRatings.vue'
import BonusRates from './views/BonusRates.vue'
import PersonnelDetails from './views/PersonnelDetails.vue'
import Users from './views/definitions/Users.vue'
import Personnels from './views/definitions/Personnels.vue'
import Customers from './views/definitions/Customers.vue'
import CustomerDetails from './views/CustomerDetails.vue'
import Products from './views/definitions/Products.vue'
import PriceModels from './views/definitions/PriceModels.vue'
import Categories from './views/definitions/Categories.vue'
import BankAccounts from './views/definitions/BankAccounts.vue'
import Periods from './views/finance/Periods.vue'
import CurrencyRates from './views/definitions/CurrencyRates.vue'
import Purchases from './views/manufacture/Purchases.vue'
import PurchaseDetails from './views/manufacture/PurchaseDetails.vue'
import WorkOrders from './views/manufacture/WorkOrders.vue'
import WorkOrderDetails from './views/manufacture/WorkOrderDetails.vue'
import Deliveries from './views/stock/Deliveries.vue'
import DeliveryDetails from './views/stock/DeliveryDetails.vue'
import Suppliers from './views/definitions/Suppliers.vue'
import MaterialCategories from './views/definitions/MaterialCategories.vue'
import Stock from './views/definitions/Stock.vue'
import BonusTypes from './views/definitions/BonusTypes.vue'
import Roles from './views/definitions/Roles.vue'
import SalesReport from './views/reports/SalesReport.vue'

import  axios  from  'axios';
import breadcrumbs from './store/breadcrumbs.js'

Vue.use(Router)

let router =  new Router({
  routes: [
    {
      path: '/welcome',
      name: 'welcome',
      component: Welcome,
      meta: { requiresAuth: true , title: 'Welcome' , hasBreadCrumb: false}
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: { requiresAuth: true , title: 'Dashboard', hasBreadCrumb: false }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { title: 'Login', hasBreadCrumb: false }
    },
    {
      path: '/resetPassword',
      name: 'resetPassword',
      component: PasswordReset,
      meta: { title: 'Password Reset' , hasBreadCrumb: false}
    },
    {
      path: '/sales',
      name: 'sales',
      component: Sales,
      meta: { requiresAuth: true , title: 'Sales', hasBreadCrumb: false }
    },
    {
      path: '/offers',
      name: 'offers',
      component: Offers,
      meta: { requiresAuth: true , title: 'Offers' , hasBreadCrumb: false}
    },
    {
      path: '/offers/:id',
      name: 'offerDetails',
      component: OfferDetails,
      meta: { requiresAuth: true , title: 'Offer Details', hasBreadCrumb: true }
    },
    {
      path: '/incomes',
      name: 'incomes',
      component: Incomes,
      meta: { requiresAuth: true , title: 'Incomes' , hasBreadCrumb: false}
    },
    {
      path: '/expenses',
      name: 'expenses',
      component: Expenses,
      meta: { requiresAuth: true , title: 'Expenses' , hasBreadCrumb: false}
    },
    {
      path: '/assumptions',
      name: 'assumptions',
      component: Assumptions,
      meta: { requiresAuth: true , title: 'Assumptions' , hasBreadCrumb: false}
    },
    {
      path: '/budgetreport',
      name: 'budgetreport',
      component: BudgetReport,
      meta: { requiresAuth: true , title: 'Budget Report' , hasBreadCrumb: false}
    },
    {
      path: '/personnelRatings',
      name: 'personnelRatings',
      component: PersonnelRatings,
      meta: { requiresAuth: true , title: 'Personnel Ratings', hasBreadCrumb: false }
    },    
    {
      path: '/bonusRates',
      name: 'bonusRates',
      component: BonusRates,
      meta: { requiresAuth: true , title: 'Bonus Rates' , hasBreadCrumb: false}
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
      meta: { requiresAuth: true , title: 'Users', hasBreadCrumb: false }
    },
    {
      path: '/roles',
      name: 'roles',
      component: Roles,
      meta: { requiresAuth: true , title: 'Roles' , hasBreadCrumb: false}
    },
    {
      path: '/personnels',
      name: 'personnels',
      component: Personnels,
      meta: { requiresAuth: true , title: 'Personnels', hasBreadCrumb: false }
    },
    {
      path: '/personnels/:id',
      name: 'personnelDetails',
      component: PersonnelDetails,
      meta: { requiresAuth: true , title: 'Personnel Details' }
    },
    {
      path: '/customers',
      name: 'customers',
      component: Customers,
      meta: { requiresAuth: true , title: 'Customers', hasBreadCrumb: false }
    },  
    {
      path: '/customers/:id',
      name: 'customerDetails',
      component: CustomerDetails,
      meta: { requiresAuth: true , title: 'Customer Details', hasBreadCrumb: true }
    },
    {
      path: '/products',
      name: 'products',
      component: Products,
      meta: { requiresAuth: true , title: 'Products', hasBreadCrumb: false }
    }, 
    {
      path: '/priceModels',
      name: 'priceModels',
      component: PriceModels,
      meta: { requiresAuth: true , title: 'Price Models', hasBreadCrumb: false }
    },   
    {
      path: '/categories',
      name: 'Categories',
      component: Categories,
      meta: { requiresAuth: true , title: 'Categories' , hasBreadCrumb: false}
    }, 
    {
      path: '/bankAccounts',
      name: 'bankAccounts',
      component: BankAccounts,
      meta: { requiresAuth: true , title: 'Bank Accounts' , hasBreadCrumb: false}
    },    
    {
      path: '/periods',
      name: 'periods',
      component: Periods,
      meta: { requiresAuth: true , title: 'Periods' , hasBreadCrumb: false}
    }, 
    {
      path: '/currencyRates',
      name: 'currencyRates',
      component: CurrencyRates,
      meta: { requiresAuth: true , title: 'Currency Rates' , hasBreadCrumb: false}
    }, 
    {
      path: '/purchases',
      name: 'purchases',
      component: Purchases,
      meta: { requiresAuth: true , title: 'Purchases' , hasBreadCrumb: false}
    },
    {
      path: '/workOrders/:id',
      name: 'workOrderDetails',
      component: WorkOrderDetails,
      meta: { requiresAuth: true , title: 'Work Order Details', hasBreadCrumb: true }
    },
    {
      path: '/workOrders',
      name: 'workOrders',
      component: WorkOrders,
      meta: { requiresAuth: true , title: 'Work Orders' , hasBreadCrumb: false}
    },
    {
      path: '/purchases/:id',
      name: 'purchaseDetails',
      component: PurchaseDetails,
      meta: { requiresAuth: true , title: 'Purchase Details', hasBreadCrumb: true }
    },
    {
      path: '/deliveries',
      name: 'deliveries',
      component: Deliveries,
      meta: { requiresAuth: true , title: 'Deliveries' , hasBreadCrumb: false}
    },
    {
      path: '/deliveries/:id',
      name: 'deliveryDetails',
      component: DeliveryDetails,
      meta: { requiresAuth: true , title: 'Delivery Details', hasBreadCrumb: true }
    },
    {
      path: '/suppliers',
      name: 'suppliers',
      component: Suppliers,
      meta: { requiresAuth: true , title: 'Suppliers' , hasBreadCrumb: false}
    }, 
    {
      path: '/materialCategories',
      name: 'materialCategories',
      component: MaterialCategories,
      meta: { requiresAuth: true , title: 'Material Categories' , hasBreadCrumb: false}
    }, 
    {
      path: '/stock',
      name: 'stock',
      component: Stock,
      meta: { requiresAuth: true , title: 'Stock' , hasBreadCrumb: false}
    }, 
    {
      path: '/bonusTypes',
      name: 'bonusTypes',
      component: BonusTypes,
      meta: { requiresAuth: true , title: 'Bonus Types' , hasBreadCrumb: false}
    },    
    {
      path: '/salesReport',
      name: 'salesReport',
      component: SalesReport,
      meta: { requiresAuth: true , title: 'Sales Report' , hasBreadCrumb: false}
    },   
  ],

});


router.beforeEach((to, from, next) => {
  if(!to.matched.some(record => record.meta.hasBreadCrumb)) {
    breadcrumbs.dispatch('setBreadCrumps', []);
  }  
  if(to.matched.some(record => record.meta.requiresAuth)) {
      if (localStorage.getItem('access_token') == null) {
          next({
              path: '/login',
              params: { nextUrl: to.fullPath }
          })
      } else {
          axios.get('https://erp.inovenso.com/erp/definitions/menuItems/user/' + localStorage.getItem('user_name'))        
          .then(response => {        
            var allowedRoute = response.data.filter((p) => {
              return (to.path.includes(p.link) || to.path=='/welcome')
            });
            if(allowedRoute.length > 0){
              next()
            }else if(response.data.length > 0){
              next({ path: response.data[0].link})
            }else{
              next({ name: 'welcome'})
            }
          }) 
          .catch(error => {            
          }); 
        
      }
  }else {
      next()
  }
})

export default router;
